/**
 * The entrypoint for the theme scripts & styles.
 *
 * Any other file in this directory can be renamed, but Webpack needs this one
 * to be here as expected :)
 */

import dropdown from './js/dropdown';
import siteHeader from './js/site-header';

dropdown();
siteHeader();

require( './js/footer-nav' );
require( './js/sticky-element' );
require( './js/locations-map' );
require( './js/embedded-forms' );
